// Central site configuration + factual data for Beacon Counseling
export const SITE = {
  name: "Beacon Counseling",
  legal: "Beacon Counseling, LLC",
  tagline: "Turning Obstacles into Opportunities",
  phone: "860-800-4758",
  phoneHref: "tel:+18608004758",
  email: "beaconcounselingoffice@gmail.com",
  emailHref: "mailto:beaconcounselingoffice@gmail.com",
  address: "209 Main Street, Southington, CT 06489",
  addressShort: "Southington, Connecticut",
  mapQuery: "209 Main Street, Southington, CT 06489",
  hours: [
    { day: "Monday – Thursday", time: "8:00 AM – 8:00 PM" },
    { day: "Friday", time: "8:00 AM – 5:00 PM" },
    { day: "Saturday", time: "Closed" },
    { day: "Sunday", time: "Closed" },
  ],
  crisis: "If you are in crisis, call or text 988 (Suicide & Crisis Lifeline) or dial 911.",
};

export const NAV = [
  { label: "Home", to: "/" },
  { label: "Pediatric Psychotherapy", to: "/pediatric-psychotherapy" },
  {
    label: "Services",
    to: "/cognitive-behavioral-therapy",
    children: [
      { label: "Cognitive Behavioral Therapy", to: "/cognitive-behavioral-therapy" },
      { label: "Pediatric Psychotherapy", to: "/pediatric-psychotherapy" },
      { label: "Individual Therapy", to: "/individual-therapy" },
      { label: "Couples Counseling", to: "/couples-counseling" },
      { label: "Children & Teens", to: "/children-and-teens" },
      { label: "Telehealth", to: "/telehealth" },
    ],
  },
  { label: "About", to: "/about" },
  { label: "Meet the Founder", to: "/therapists" },
  { label: "Insurance & Fees", to: "/insurance-and-fees" },
  { label: "Resources", to: "/resources" },
  { label: "Contact", to: "/contact" },
];

export const SERVICE_OPTIONS = [
  "Individual Therapy",
  "Couples Counseling",
  "Children & Teens",
  "Anxiety Treatment",
  "Depression Treatment",
  "OCD Treatment",
  "Trauma / PTSD",
  "Not sure yet",
];
